import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant';
import 'vant/lib/index.css';
import { Lazyload } from 'vant';
// import Vuei18n from "vue-i18n";
import md5 from 'js-md5';
// import axios from 'axios'
import {i18nInit} from './plugins/i18n'
// 前端异常情况捕获
Vue.prototype.$md5 = md5;
const i18n=i18nInit()
// Vue.use(Vuei18n);
Vue.use(Lazyload);
Vue.use(Vant);


// const i18n = new Vuei18n({
//     locale: 'en-US',
// });
// window.i18n = i18n
//     //从utils库内获取多语言文件，并配置
// let messages = {
//     'zh-CN': '/json/zh_CN.json',
//     'en-US': '/json/en_US.json',
//     'zh-TW': '/json/zh_HK.json',
//     'zh-HK': '/json/zh_HK.json',
//     'ko-KR': '/json/ko_KR.json',
//     'id-ID': '/json/id_ID.json',
//     'ja-JP': '/json/ja_JP.json',
//     'vi-VN': '/json/vi_VN.json',
//     'th-TH': '/json/th_TH.json',
//     'ru-RU': '/json/ru_RU.json',
// }
// let promiseArr = []
// Object.keys(messages).map(lang => {
//     promiseArr.push(axios({
//         url: CONFIG.utilsUrl + messages[lang],
//         data: {lang}
//     }))
// })
// const p = Promise.all(promiseArr)
// p.then(res => {
//     res.forEach(i => {
//         const lang = JSON.parse(i.config.data).lang
//         window.i18n.setLocaleMessage(lang, i.data)
//     })
//     store.commit('INIT',{
//         showPage: true
//     })
// })
Vue.config.productionTip = false

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')